import { render, staticRenderFns } from "./SectionSeperator.vue?vue&type=template&id=43220c51&"
import script from "./SectionSeperator.vue?vue&type=script&lang=js&"
export * from "./SectionSeperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports